import React from 'react';
import { Row, Col } from '../../../components/grid';
import MultiCategoryDisplay from '../layout/MainBestilLayout/MultiCategoryDisplay';

export default () => (
  <React.Fragment>
    <Row>
      <Col xs={12}>
        <MultiCategoryDisplay page="FadoelOgAnlaeg" subPage="OelGlas" />
      </Col>
    </Row>
  </React.Fragment>
);
